export const PRODUCT_CONFIG = {
    NAME: 'einvCompanion',
};
